import { render, staticRenderFns } from "./ListInteractionComponent.vue?vue&type=template&id=5a883474&"
import script from "./ListInteractionComponent.vue?vue&type=script&lang=js&"
export * from "./ListInteractionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports